import { render, staticRenderFns } from "./custom-num.vue?vue&type=template&id=04b75428&scoped=true&"
import script from "./custom-num.vue?vue&type=script&lang=js&"
export * from "./custom-num.vue?vue&type=script&lang=js&"
import style0 from "./custom-num.vue?vue&type=style&index=0&id=04b75428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b75428",
  null
  
)

export default component.exports